import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CollapseBlock } from '../../../../../common';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField';
import FormButton from '../../../../../antd/form/FormButton/FormButton';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer';
import Form from '../../../../../antd/form/Form/Form';
import Fomrular from 'antd/es/form/Form';
import { useDataGridTextFilter } from '../../../../../common/DataGrid/filters/useDataGridTextFilter';
import { dataGridTextSorter } from '../../../../../common/DataGrid/sorters/DataGridSorters';
import DataGrid from '../../../../../common/DataGrid/DataGrid';
import PropTypes from 'prop-types';
import {
  PlusCircleFilled,
  MinusCircleFilled,
  DeleteFilled,
} from '@ant-design/icons';
import { IconButton } from '../../../../../common/controls/Controls';
import FormSelect from '../../../../../antd/form/FormSelect/FormSelect';
import { Button } from 'antd';

const AttendanceEventDetailStudentsForm = ({
  students,
  allUsers,
  changePoints,
  onDelete,
  onSubmit,
  isLoading,
}) => {
  const { t } = useTranslation();
  const titleTextFilterProps = useDataGridTextFilter('title');

  const [form] = Fomrular.useForm();

  function handleUserInfoChange(event, type) {
    form.setFieldsValue({
      // Update the form fields
      card_number: type === 'card_number' ? event : undefined,
      person_id: type === 'person_id' ? event : undefined,
    });
  }

  const handleSubmit = async (values) => {
    await onSubmit(values); // Submit the form data
    form.resetFields(); // Reset all fields after successful submission
  };

  const columns = useMemo(
    () => [
      {
        title: t('Meno účastníka'),
        dataIndex: ['person_id', 'full_name'],
        sorter: dataGridTextSorter('person_id.last_name'),
        eclipsis: true,
        ...titleTextFilterProps,
      },
      {
        title: t('Body'),
        dataIndex: 'points',
        ellipsis: true,
        //render: (person) => `${person?.title_before || ''} ${person?.first_name} ${person?.last_name} ${person?.title_after || ''}`.trim(),
        sorter: dataGridTextSorter('points'),
        ...titleTextFilterProps,
      },
    ],
    [t, titleTextFilterProps],
  );

  const customSettings = (row) => {
    return (
      <div style={{ display: 'flex' }}>
        <IconButton
          icon={<MinusCircleFilled />}
          tooltip={t('Odobrať bod')}
          onClick={() => {
            changePoints(false, 'substract', row);
          }}
        />
        <IconButton
          icon={<PlusCircleFilled />}
          tooltip={t('Pridať bod')}
          onClick={() => {
            changePoints(false, 'add', row);
          }}
        />
      </div>
    );
  };

  return (
    <CollapseBlock collapsible title={t('Študenti prítomní na udalosti')}>
      <Form form={form} onFinish={handleSubmit}>
        <FormTextField
          label={t('Číslo karty')}
          name={'card_number'}
          autoFocus={true}
          autoComplete={false}
          onChange={(event) =>
            handleUserInfoChange(event.target.value, 'card_number')
          }
        />
        <FormSelect
          label={t('Účastník')}
          name={'person_id'}
          options={allUsers}
          onChange={(value) => handleUserInfoChange(value, 'person_id')}
        />
        <FormButtonsContainer>
          <FormButton submitOnClick={true} submitKey={'attendanceEvents'}>
            {t('Pridaj študenta')}
          </FormButton>
        </FormButtonsContainer>
      </Form>

      <Button
        type="primary"
        style={{ margin: '10px', float: 'right' }}
        onClick={() => {
          changePoints(true, 'add');
        }}
      >
        {t('Pridať bod všetkým')}
      </Button>
      <Button
        type="primary"
        style={{ margin: '10px', float: 'right' }}
        onClick={() => {
          changePoints(true, 'substract');
        }}
      >
        {t('Odobrať bod všetkým')}
      </Button>
      <br />
      <br />
      {isLoading ? (
        <p>{t('Načítavam študentov')}...</p>
      ) : (
        <DataGrid
          key={students?.length}
          rowKey={(student) => student.id}
          columns={columns}
          dataSource={students || []}
          permissionsBasic={'attendance.show'}
          customSettings={customSettings}
          onDelete={(row) => onDelete(row)}
        />
      )}
    </CollapseBlock>
  );
};

AttendanceEventDetailStudentsForm.propTypes = {
  students: PropTypes.array,
  allUsers: PropTypes.array,
  changePoints: PropTypes.func,
  onSubmit: PropTypes.func,
  onDelete: PropTypes.func,
  isLoading: PropTypes.bool,
};

export default AttendanceEventDetailStudentsForm;
